import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'

const path = typeof window !== 'undefined' ? window.location.pathname : '/'
const isManage = path === '/manage' || path.startsWith('/manage/')
const isReports = path === '/reports' || path.startsWith('/reports/')
const RouteApp = isManage
  ? lazy(() => import('./manage/ManageApp'))
  : isReports
    ? lazy(() => import('./account/ReportsApp'))
    : lazy(() => import('./App'))

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={<main className="route-loading" role="status">Loading…</main>}>
      <RouteApp />
    </Suspense>
  </React.StrictMode>,
)
